// AddDatabaseModalLandingStep.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Components
import AddDatabaseModalOption from './option/AddDatabaseModalOption';

/**
 * AddDatabaseModalLandingStep
 *
 * Renders the landing step for choosing how to start a new database.
 *
 * @param {function} onOpenCreateFlow - Opens the create-from-scratch flow.
 * @param {function} onOpenTemplateFlow - Opens the template provisioning flow.
 *
 * @returns {ReactNode} The rendered landing step.
 */
const AddDatabaseModalLandingStep = ({
    onOpenCreateFlow,
    onOpenTemplateFlow,
}) => {
    const { theme } = useTheme();

    return (
        <div className="add-database-modal-landing">
            <div
                className="add-database-modal-landing-hint"
                style={{
                    color: theme.foregroundMuted,
                }}
            >
                Choose how you want to set up your new database.
            </div>

            <AddDatabaseModalOption
                iconKey="add_circle"
                title="Create New"
                subtitle="Build a custom database from scratch"
                onClick={onOpenCreateFlow}
            />

            <AddDatabaseModalOption
                iconKey="library_books"
                title="Choose a Template"
                subtitle="Start from a pre-built database with common fields"
                onClick={onOpenTemplateFlow}
            />
        </div>
    );
};

export default AddDatabaseModalLandingStep;